import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { intl } from 'components/LocaleProvider';
import Icon from 'base-ui/dist/Icon';
import { useAmp } from 'next/amp';
import RenderHtmlReact from 'utils/RenderHtmlReact';
import messages from './messages';

const PostBibliography = ({ bibliography }) => {
  const [showBibliography, setShowBibliography] = useState(false);

  if (bibliography) {
    return (
      <div className="single-bibliography">
        {useAmp() ? (
          <button
            id="bibliographyButton"
            data-with-google-events="true"
            data-google-events={JSON.stringify({
              data: {
                action: 'click',
                category: 'Button',
                label: 'Bibliography'
              }
            })}
            type="button"
            on="tap:bibliographyTextContent.toggleClass(class='open'),bibliographyButton.toggleClass(class='open')"
            className="btn white-bg grey-border bibliography-button title-color"
          >
            {`${intl.formatMessage(messages.bibliography)}`}
            {' '}
            <Icon prefix="fas" name="plus" color="main" />
          </button>
        ) : (
          <button
            id="bibliographyButton"
            data-with-google-events="true"
            data-google-events={JSON.stringify({
              data: {
                action: 'click',
                category: 'Button',
                label: 'Bibliography'
              }
            })}
            type="button"
            className={`btn white-bg grey-border text-color bibliography-button ${showBibliography ? 'open' : ''}`}
            onClick={() => setShowBibliography((show) => !show)}
          >
            {`${intl.formatMessage(messages.bibliography)}`}
            {' '}
            <Icon prefix="fas" name="plus" color="main" />
          </button>
        )}
        <div
          id="bibliographyTextContent"
          className={`message bibliography ${showBibliography ? 'open' : ''}`}
        >
          <RenderHtmlReact
            text={bibliography}
          />
        </div>
      </div>
    );
  }

  return null;
};

PostBibliography.propTypes = {
  bibliography: PropTypes.string
};

export default PostBibliography;
